(function () {
  const rawContent = document.getElementById('glossary-raw-content');
  const columnsWrap = document.getElementById('glossary-columns');
  const searchInput = document.getElementById('glossary-search');
  const azNav = document.getElementById('glossary-az');
  const noResults = document.getElementById('glossary-no-results');

  if (!rawContent || !columnsWrap) return;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = rawContent.innerHTML;
  const paragraphs = Array.from(tempDiv.querySelectorAll('p'));

  const terms = [];

  paragraphs.forEach(function (p) {
    const redSpan = p.querySelector('span[style*="color"]');
    if (!redSpan) return;

    const strong = redSpan.querySelector('strong') || (redSpan.tagName === 'STRONG' ? redSpan : null);
    if (!strong) return;

    const termText = strong.textContent.replace(/:$/, '').trim();
    if (!termText) return;

    const clone = p.cloneNode(true);
    const cloneRedSpan = clone.querySelector('span[style*="color"]');
    if (cloneRedSpan) cloneRedSpan.remove();

    const defText = clone.textContent.replace(/^\s*[\r\n]+/, '').trim();
    const firstLetter = termText[0].toUpperCase();

    terms.push({ term: termText, def: defText, letter: firstLetter });
  });

  const usedLetters = new Set(terms.map(t => t.letter));

  document.querySelectorAll('.az-btn').forEach(btn => {
    if (!usedLetters.has(btn.dataset.letter)) {
      btn.classList.add('disabled');
    } else {
      btn.classList.remove('disabled');
    }
  });

  function renderColumns(termList) {
    columnsWrap.innerHTML = '';
    if (!termList.length) {
      noResults.style.display = 'block';
      return;
    }
    noResults.style.display = 'none';

    const cols = [document.createElement('div'), document.createElement('div'), document.createElement('div')];

    termList.forEach((t, idx) => {
      const colIndex = idx % 3;

      const entry = document.createElement('div');
      entry.className = 'glossary-entry';
      entry.dataset.letter = t.letter;

      const term = document.createElement('div');
      term.className = 'glossary-entry-term';
      term.textContent = t.term;

      const def = document.createElement('div');
      def.className = 'glossary-entry-def';
      def.textContent = t.def;

      entry.appendChild(term);
      if (t.def) entry.appendChild(def);
      cols[colIndex].appendChild(entry);
    });

    cols.forEach(col => columnsWrap.appendChild(col));
  }

  let activeLetter = null;
  let searchQuery = '';

  function getFilteredTerms() {
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      return terms.filter(t => t.term.toLowerCase().includes(q) || t.def.toLowerCase().includes(q));
    }
    if (activeLetter) return terms.filter(t => t.letter === activeLetter);
    return terms;
  }

  function refresh() {
    document.querySelectorAll('.az-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.letter === activeLetter);
    });
    renderColumns(getFilteredTerms());
  }

  azNav.addEventListener('click', function (e) {
    const btn = e.target.closest('.az-btn');
    if (!btn || btn.classList.contains('disabled')) return;
    activeLetter = activeLetter === btn.dataset.letter ? null : btn.dataset.letter;
    searchInput.value = '';
    searchQuery = '';
    refresh();
  });

  searchInput.addEventListener('input', function () {
    searchQuery = this.value.trim();
    activeLetter = null;
    refresh();
  });

  refresh();
})();